import { uniq } from "lodash";
import {
  BulkTargets,
  SchoolFormId,
  SchoolFormKeyRecordFactory,
} from "../types";

export function resolveSummaryFormIds(
  bulkTargets: BulkTargets,
  listItems?: SchoolFormId[]
): uuid[] {
  if ("inclusion" in bulkTargets) {
    return uniq(bulkTargets.inclusion.map((target) => target.formId));
  }
  if (!listItems?.length) {
    return [];
  }
  return uniq(
    listItems
      .filter((item) => {
        const key = SchoolFormKeyRecordFactory(item);
        return !bulkTargets.exclusion.some((excluded) =>
          key.equals(SchoolFormKeyRecordFactory(excluded))
        );
      })
      .map((item) => item.formId)
  );
}
